<div class="cpcontent">
    <h2>Test Reset Your Password</h2>
    <div style="max-width:300px">
        <sa-select [title]="'Select User'" [(Id)]="userid" [options]="users" [NameField]="'email'"></sa-select>
    </div>
    <br><br>
    <button class="btn btn-primary" (click)="sendEmail()">Send Email</button>
</div>
